import { Injectable } from '@angular/core';


import { HttpClient } from '@angular/common/http';
import { GlobalConstants } from '../Constants/global.constants';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DeviceMapService {

    constructor(private _http: HttpClient) { }
    getAlldeviceMap(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'FloorDevice/Filter';
        return this._http.post(url, request);
    }

    adddeviceMap(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'FloorDevice/Create';
        return this._http.post(url, request);
    }

    deletedeviceMap(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + `FloorDevice/Delete?id=` + request;
        return this._http.delete(url, request);
    }

    update(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'FloorDevice/Update?id=' + request.id;
        return this._http.put(url, request);
    }

    getdeviceMapDropdown(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'FloorDevice/GetAllForDropDown';
        return this._http.get(url);
    }


}